module.exports = __webpack_public_path__ + "img/cross-filled.24d0005c.svg";